(function(){
  var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ---- slow reveals ---- */
  var rv = [].slice.call(document.querySelectorAll(".rv"));
  if(reduce || !("IntersectionObserver" in window)){
    rv.forEach(function(el){ el.classList.add("in"); });
  } else {
    var io = new IntersectionObserver(function(es){
      es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add("in"); io.unobserve(e.target); } });
    },{rootMargin:"0px 0px -10% 0px",threshold:.12});
    rv.forEach(function(el){ io.observe(el); });
  }

  /* ---- the race ---- */
  var FLAT_S = 30, PAW_S = 300;        /* real world seconds */
  var PLAY_MS = 14000;                 /* how long the demo runs on screen */
  var foodFlat = document.getElementById("foodFlat");
  var foodPaw  = document.getElementById("foodPaw");
  var stFlat = document.getElementById("stFlat");
  var stPaw  = document.getElementById("stPaw");
  var clock  = document.getElementById("clock");
  var playBtn = document.getElementById("playBtn");

  /* interior bounds inside each bowl path */
  var FLAT_TOP = 62, FLAT_BOT = 88;
  var PAW_TOP = 42,  PAW_BOT = 78;
  var raf = 0, t0 = 0, running = false;

  function mmss(s){
    var m = Math.floor(s/60), r = Math.floor(s%60);
    return m + ":" + (r<10?"0":"") + r;
  }
  function setLevel(el, top, bot, remaining){
    var y = top + (1-remaining)*(bot-top);
    el.setAttribute("y", y.toFixed(2));
    el.setAttribute("height", Math.max(0,(bot-y)).toFixed(2));
  }
  function reset(){
    setLevel(foodFlat, FLAT_TOP, FLAT_BOT, 1);
    setLevel(foodPaw,  PAW_TOP,  PAW_BOT,  1);
    stFlat.textContent = "Full"; stPaw.textContent = "Full";
    clock.textContent = "0:00";
  }
  function frame(ts){
    if(!t0) t0 = ts;
    var p = Math.min(1,(ts-t0)/PLAY_MS);
    var simSec = p * PAW_S;
    clock.textContent = mmss(simSec);

    var fRem = Math.max(0, 1 - simSec/FLAT_S);
    var pRem = Math.max(0, 1 - simSec/PAW_S);
    setLevel(foodFlat, FLAT_TOP, FLAT_BOT, fRem);
    setLevel(foodPaw,  PAW_TOP,  PAW_BOT,  pRem);

    stFlat.textContent = fRem <= 0 ? "Empty at 0:30" : Math.round(fRem*100) + "% left";
    stPaw.textContent  = pRem <= 0 ? "Empty at 5:00" : Math.round(pRem*100) + "% left";

    if(p < 1){ raf = requestAnimationFrame(frame); }
    else { running = false; playBtn.textContent = "Play again"; }
  }
  function play(){
    cancelAnimationFrame(raf); t0 = 0; running = true;
    playBtn.textContent = "Running";
    reset(); raf = requestAnimationFrame(frame);
  }
  if(foodFlat && playBtn){
    reset();
    playBtn.addEventListener("click", play);
    if(!reduce && "IntersectionObserver" in window){
      var seen = false;
      var io2 = new IntersectionObserver(function(es){
        es.forEach(function(e){ if(e.isIntersecting && !seen){ seen = true; play(); io2.disconnect(); } });
      },{threshold:.4});
      io2.observe(document.getElementById("race"));
    }
  }

  /* ---- fit checker ---- */
  var FIT = {
    cat:   { k:"yes",  t:"Yes, comfortably.",       p:"100 ml is a full meal for most cats, so one fill and you are done. This bowl was shaped for cats first, which is why it has the ears." },
    small: { k:"yes",  t:"Yes.",                    p:"Puppies and small pets up to 10 lb are well served by a 100 ml bowl. Most owners find it is one meal, occasionally two smaller ones." },
    big:   { k:"part", t:"It will work, with a refill.", p:"Over 10 lb your pet will likely finish 100 ml and want more, so you would be filling it twice. The slowing still works, but if you want one fill per meal this is the wrong size and we would rather say so." }
  };
  var fitout = document.getElementById("fitout");
  var fitbtns = [].slice.call(document.querySelectorAll(".fitbtns button"));
  function showFit(key){
    var f = FIT[key]; if(!f || !fitout) return;
    fitout.style.opacity = "0";
    setTimeout(function(){
      fitout.innerHTML = '<div class="verdict ' + f.k + '">' + f.t + '</div><p>' + f.p + '</p>';
      fitout.style.opacity = "1";
    }, 180);
    fitbtns.forEach(function(b){ b.classList.toggle("on", b.getAttribute("data-fit") === key); });
  }
  if(fitbtns.length){
    fitbtns.forEach(function(b){
      b.addEventListener("click", function(){ showFit(b.getAttribute("data-fit")); });
    });
    var f0 = FIT.cat;
    fitout.innerHTML = '<div class="verdict ' + f0.k + '">' + f0.t + '</div><p>' + f0.p + '</p>';
  }

})();
